// extracted by mini-css-extract-plugin
module.exports = {"page":"layout_page__3QO8o","content":"layout_content__w92gD","wrapper":"layout_wrapper__4LQCZ","loadingContainer":"layout_loadingContainer__6TFTR"};